export default __webpack_public_path__ + "static/qr-shop-taobao-035862004087b8fbbc8ecbe8e14a8987.jpg";